import { useState } from "react";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCustomers } from "./customers/useCustomers";
import { CustomerTable } from "./customers/CustomerTable";
import { CustomerFormDialog } from "./customers/CustomerFormDialog";
import { CustomerApproveDialog } from "./customers/CustomerApproveDialog";
import { SetPasswordDialog } from "./customers/SetPasswordDialog";

export default function AdminCustomers() {
  const { customers, createCustomer, updateCustomer, removeCustomer, toggleBlock, approveCustomer, setPassword } = useCustomers();
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [approving, setApproving] = useState(null);
  const [passwordFor, setPasswordFor] = useState(null);

  const openCreate = () => { setEditing(null); setFormOpen(true); };
  const openEdit = (c) => { setEditing(c); setFormOpen(true); };

  const handleDelete = async (id) => {
    if (!window.confirm("Move customer to trash?")) return;
    try { await removeCustomer(id); } catch (e) { toast.error(formatApiError(e)); }
  };

  const handleToggleBlock = async (c) => {
    const blocked = c.status === "blocked";
    if (!window.confirm(blocked ? "Allow this customer to log in again?" : "Restrict this customer from logging in?")) return;
    try { await toggleBlock(c); } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-heading font-semibold tracking-tight" data-testid="admin-customers-title">Customers</h1>
        <Button onClick={openCreate} className="bg-[#002fa7] hover:bg-[#00227b] rounded-sm" data-testid="admin-new-customer-btn">
          <Plus className="w-4 h-4 mr-1" strokeWidth={1.5}/> Add customer
        </Button>
      </div>

      <CustomerTable
        customers={customers}
        onApprove={setApproving}
        onToggleBlock={handleToggleBlock}
        onEdit={openEdit}
        onDelete={handleDelete}
        onSetPassword={setPasswordFor}
      />

      <CustomerFormDialog
        open={formOpen}
        onOpenChange={setFormOpen}
        editing={editing}
        onCreate={createCustomer}
        onUpdate={updateCustomer}
      />

      <CustomerApproveDialog
        customer={approving}
        onClose={() => setApproving(null)}
        onApprove={approveCustomer}
      />

      <SetPasswordDialog
        customer={passwordFor}
        onClose={() => setPasswordFor(null)}
        onSetPassword={setPassword}
      />
    </div>
  );
}
